import React from 'react';

export default function Toggle({ checked, onChange, accent }) {
  const ac = accent || '#CC1A00';
  return (
    <button
      onClick={() => onChange(!checked)}
      aria-checked={checked}
      role="switch"
      style={{
        width: 40, height: 22, borderRadius: 11, border: 'none',
        background: checked ? ac : '#D1D5DB',
        position: 'relative', cursor: 'pointer',
        transition: 'background 0.2s', flexShrink: 0, padding: 0,
      }}
    >
      <div style={{
        width: 18, height: 18, borderRadius: 9, background: 'white',
        position: 'absolute', top: 2,
        left: checked ? 20 : 2,
        transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
      }} />
    </button>
  );
}
